import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LocaleState {
  loading: boolean;
}

const initialState: LocaleState = {
  loading: true,
};

export const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setLoading } = localeSlice.actions;
export default localeSlice.reducer;
